import type { Flag } from '../types';
import { Actions } from './actions';
import css from './controls.module.scss';
import { New } from './new';
import { Stats } from './stats';

interface Props {
    flags: Flag[];
}
export function Controls({ flags }: Props) {
    return (
        <div className={css.controls}>
            <Stats flags={flags} />
            <New />
            <Actions />
        </div>
    );
}
